import { render, staticRenderFns } from "./PatentForm.vue?vue&type=template&id=2b2d8e3e&"
import script from "./PatentForm.vue?vue&type=script&lang=js&"
export * from "./PatentForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentForm.vue?vue&type=style&index=0&id=2b2d8e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports